import { AUTH_COOKIE_NAME, TTP_API_URL, COOKIES_DATA } from "Config";
import axios from "axios";

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

export function setCookie(name, value, expires, path, domain, secure) {
  document.cookie =
    name +
    " = " +
    encodeURI(value) +
    "  " +
    (!expires ? "" : "; expires = " + expires.toUTCString()) +
    (!path ? "" : "; path = " + path) +
    (!domain ? "" : "; domain = " + domain) +
    (secure === true ? "; secure" : "");
}

export const getAuthInfosFromCookie = () => {
  const cookie = getCookie(AUTH_COOKIE_NAME);

  if (!cookie) {
    return;
  }

  return JSON.parse(cookie);
};

export const authHasExpired = authInfos => {
  const now = Math.floor(new Date().getTime() / 1000);

  return (
    !authInfos ||
    typeof authInfos !== "object" ||
    !authInfos.createdAt ||
    !authInfos.expiresIn ||
    now >= authInfos.createdAt * 1 + authInfos.expiresIn * 1
  );
};

export const getLocalStorageAuth = () => {
  const stringAuth = localStorage.getItem("auth");
  let auth = {};

  try {
    auth = JSON.parse(stringAuth);
  } catch (e) {}
  return typeof auth === "object" ? auth : {};
};

export const setLocalStorageAuth = auth => {
  if (typeof auth === "object") {
    localStorage.setItem("auth", JSON.stringify(auth));
    return auth;
  }
  if (auth == null) {
    localStorage.removeItem("auth");
  }
};

export const preConfigureHttpRequests = () => {
  axios.interceptors.request.use(
    config => {
      if (config.url.match(/^([a-z0-9]+):\/\//)) {
        return config;
      }

      let { currentOrganization, token } = getLocalStorageAuth();
      if (currentOrganization && token) {
        config.url = [`${TTP_API_URL}`, config.url].join("");
        config.params = {
          organization_id: currentOrganization.id,
          access_token: token,
          ...config.params
        };
      }

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

export const setLocalStorageCookie = cookie_auth => {
  if (cookie_auth && typeof cookie_auth === "object") {
    localStorage.setItem("cookie_auth", JSON.stringify(cookie_auth));
    return cookie_auth;
  }
  if (cookie_auth == null) {
    localStorage.removeItem("cookie_auth");
  }
};

export const clearAllCookies = (callback = null) => {
  const cookies = COOKIES_DATA;
  const dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);
  for (let i = 0; i < cookies.length; i++) {
    setCookie(cookies[i], "", dtExpire, "/", "tamtam.pro");
  }
  callback && callback();
};



// WEBPACK FOOTER //
// ./src/utils/auth.js